import { Outlet } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";
import "./Main.scss";

const Main = () => {
  return (
    <div className="main">
      <Navbar />
      <div className="main-container">
        <div className="main-menu">
          <Sidebar />
        </div>
        <div className="main-content container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Main;
